import { IPromise } from 'angular';

import { RequestHelper } from '../../ts/helpers/RequestHelper';
import { ResultHelper } from '../../ts/helpers/ResultHelper';
import { Module } from '../../ts/Module';
import { DeleteFlowVersionsRequest } from '../../ts/ServerApi/requests/DeleteFlowVersionsRequest';
import { GetFlowVersionsRequest, GetFlowVersionsResult } from '../serverApi/requests/GetFlowVersionsRequest';
import { FlowRevision } from '../serverApi/types/FlowRevision';
import { IResult } from '../../ts/ServerApi/types/IResponse';
import { ErrorNotifyingServer } from '../../ts/services/ErrorNotifyingServer';
import { FetcherFactory } from '../../ts/services/FetcherFactory';
import { ServerService } from '../../ts/services/ServerService';
import { Resource } from '../../ts/resources/Resource';

export class FlowRevisions extends Resource<FlowRevision>  {

  public static $inject = ['ErrorNotifyingServer', 'FetcherFactory'];

  private server: ServerService;

  constructor(private ErrorNotifyingServer: ErrorNotifyingServer, FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetFlowVersionsRequest,
      (result: GetFlowVersionsResult) => result.versions));

    this.server = ErrorNotifyingServer.getServerService();
  }

  public del = (id: string): IPromise<IResult> => {
    return this.ErrorNotifyingServer.sendRequestsAndDelay(
      RequestHelper.buildRequests([id], (idsBlock) => new DeleteFlowVersionsRequest(idsBlock)),
      ResultHelper.combineResults);
  }
}

Module.instance().service('FlowRevisions', FlowRevisions);
